import Vue from 'vue'
import Vuex from 'vuex'
import { removeToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false // 默认未登录
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn
  },
  mutations: {
    setLoginState (state, status) {
      state.isLoggedIn = status
    }
  },
  actions: {
    login ({ commit }) {
      // 假设这里是你登录的逻辑
      commit('setLoginState', true)
    },
    logout ({ commit }) {
      
      commit('setLoginState', false)
    }
  },
  modules: {
    
  }
})
